// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__K4toN","line":"Separator_line__FC2ac","label":"Separator_label__UhPpN"};